import axios from 'axios';
import i18next from 'i18next';
import localforage from 'localforage';
import { getConfig } from '../../../config/apiConfig';
import { getIdbItem, setIdbItem } from '../../../utils/clientStorage';
import getLogger from '../../../utils/logger';

const getTranslationCategoryHash = async () => {
  const config = await getConfig();
  return axios
    .get('api/i18n/categoryhash', config)
    .then((response) => {
      if (response && response.data) {
        return JSON.parse(response.data);
      }
      return [];
    })
    .catch((err) => {
      getLogger().error(err);
      return [];
    });
};

const refreshOutdatedTranslations = async () => {
  const cachedHash = await getIdbItem('translationHash');
  const keysToUpdate = [];
  let hashChanged = false;
  let store;
  return getTranslationCategoryHash()
    .then(async (response) => {
      if (!cachedHash || cachedHash.length === 0) {
        // If translation category hash is not present then update the hash in indexedDB
        await setIdbItem('translationHash', response);
        return null;
      }

      const keys = Object.keys(response);

      // eslint-disable-next-line no-restricted-syntax
      for (const k of keys) {
        if (cachedHash[k] && cachedHash[k] !== response[k]) {
          if (!hashChanged) {
            hashChanged = true;
            store = localforage.createInstance({
              name: 'ST',
              storeName: 'rcore'
            });
          }
          // Below check is to ensure we reload only the categories that are already loaded by rcore.
          // using 'en-Us' language as it is configured to be the fallback language for i18n instance.
          // eslint-disable-next-line no-await-in-loop
          const category = await store.getItem(`en-US-${k}`);
          if (category) keysToUpdate.push(k);
        }
      }
      // Update the hash in indexedDB when there is a change in hash for atleast one category.
      if (hashChanged) await setIdbItem('translationHash', response);

      if (keysToUpdate.length > 0) {
        await i18next.reloadResources(null, keysToUpdate);
      }
      return null;
    })
    .catch((err) => {
      getLogger().error('Error in refreshing translations', err);
    });
};

export { getTranslationCategoryHash, refreshOutdatedTranslations };
